import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { GetDeliveryResponse } from './delivery-service.model';
import { DeliveryLine, DeliveryTableLine } from '../models/delivery.model';

@Injectable({
  providedIn: 'root',
})
export class DeliveryService {
  protected baseUrl = `${this.env.API_BASE_URL}/service/pig-registration/secure/delivery-line`;

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: { API_BASE_URL: string },
  ) {}

  getDeliveries(
    startDate?: string,
    endDate?: string,
    locations?: number[],
  ): Observable<DeliveryLine[] | HttpErrorResponse> {
    let params = {};
    if (!!startDate && !!endDate) {
      params = {
        startDate,
        endDate,
      };
    }
    if (!!locations && locations.length > 0) {
      params = {
        ...params,
        LocationIds: locations,
      };
    }
    return this.http.get<GetDeliveryResponse>(`${this.baseUrl}`, { params }).pipe(
      map((response) => response.deliveryLines),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<DeliveryLine[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  upsertDelivery(delivery: DeliveryTableLine): Observable<unknown | HttpErrorResponse> {
    return this.http
      .patch(`${this.baseUrl}/${delivery.id}`, {
        isActive: delivery.isActive,
        locationId: delivery.locationId,
      })
      .pipe(
        map((d) => d),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of({});
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }
}
